export default __webpack_public_path__ + "static/media/landing_KOR_03.64ca7bc4.png";